import { EngagementLevel } from 'model';
import { useLoggedIn } from './useLoggedIn.js';
import { useGetOwnProfileQuery } from '../api/UserApi.js';
import { useLoginState } from './useLoginState.js';

/**
 * Hook to get the current user's EngagementLevel preference
 * @returns { EngagementLevel } the current user's EngagementLevel preference
 */
export function useEngagementLevel(): EngagementLevel {
	const loginState = useLoginState();
	const { realUser } = useLoggedIn();
	const { data: { engagementLevel } = { engagementLevel: 'none' } } = useGetOwnProfileQuery(loginState?.user._id, {
		skip: !realUser
	});
	return engagementLevel;
}
